var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "crud crud-list" },
    [
      _c("div", { staticClass: "info-div" }, [
        _c("h1", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("__.Components.parent.nfe.list_vue_html.nfe"))),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [
          _c("div", { staticClass: "info-panel" }, [
            _c("span", [_vm._v(_vm._s(_vm.total))]),
            _vm._v(" "),
            _c("span", [
              _vm._v(
                _vm._s(_vm.$t("__.Components.parent.nfe.list_vue_html.nf"))
              ),
            ]),
            _vm._v(" "),
            _c("span", [
              _vm._v(
                _vm._s(
                  _vm.$t("__.Components.parent.nfe.list_vue_html.emitidas")
                )
              ),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("grid-component", {
        attrs: {
          data: _vm.gridData,
          columns: _vm.gridColumns,
          "page-index": _vm.pageIndex,
          "page-size": _vm.pageSize,
          "show-action-column": true,
          "show-edit-item": false,
          "show-remove-item": false,
          "show-table-foot": true,
          "show-table-head": true,
          startFilterKey: _vm.startFilterKey,
          tituloPagina: "NFE",
          total: _vm.total,
          extraActions: _vm.extraActions,
        },
        on: {
          "change-filter-key": _vm.onChangeFilterKey,
          "change-page": _vm.onChangePage,
          "change-sort": _vm.onChangeSort,
          "create-item": _vm.onCreateItem,
          "extra-action": _vm.onExtraAction,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }